module.exports = __webpack_public_path__ + "fonts/Calibre-Semibold.d8b85647.woff2";